import { observer } from 'mobx-react';
import * as React from 'react';
import { findField } from '../../../../../../Resource/FormTemplates/Types';
import LearningCollectionEditStore from '../../../Edit/Store';
import { Section, sectionContext } from '../../../Types';
import ExperienceCatalog from '../ExperienceCatalog';
import { LearningCollectionEditFormResource } from '../../../Edit/Store/Types';

interface Props {
  store: LearningCollectionEditStore;
  section: Section;
  learningCollectionEditFormResource: LearningCollectionEditFormResource;
}

const ExperienceCatalogButton: React.FC<Props> = ({
  store,
  section,
  learningCollectionEditFormResource,
}) => {
  switch (section.resource.payload.learningDesignState) {
    case 'blank':
    case 'custom':
    case 'curated-custom':
    case 'build-your-own':
    case 'browse-all':
      return findField('name', 'string', section.template.fields)
        .map((name) => (
          <ExperienceCatalog
            learningDesignName={{ kind: 'already-translated-text', text: name.value }}
            learningCollectionStore={store}
            context={sectionContext(section)}
            learningCollectionEditFormResource={learningCollectionEditFormResource}
          />
        ))
        .getOrElse(() => <></>);
    case 'curated':
    case 'empty':
      return <></>;
  }
};

export default observer(ExperienceCatalogButton);
